import React, { useState, useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import Sidebar from "./Components/Sidebar";
import HomePage from "./Pages/HomePage";
import AboutPage from './Pages/AboutPage';
import SkillsPage from './Pages/SkillsPage';
import ProjectsPage from './Pages/ProjectsPage';
import ContactPage from './Pages/ContactPage';
import BrightnessHighRoundedIcon from '@mui/icons-material/BrightnessHighRounded';
import MenuOutlinedIcon from '@mui/icons-material/MenuOutlined';
import { IconButton, Switch } from '@mui/material';
import styled from 'styled-components'
import axios from "axios";
// import swal from 'sweetalert';

const MainContentStyled = styled.main`
    position: relative;
    margin-left: 16.3rem;
    min-height: 100vh;
    @media screen and (max-width:1200px){
        margin-left: 0;
    }
    .lines{
        position: absolute;
        min-height: 100%;
        width: 100%;
        display: flex;
        justify-content: space-evenly;
        opacity: 0.4;
        z-index: -1;
    .line-1, .line-2, .line-3, .line-4{
        width: 1px;
        min-height: 100vh;
        background-color: var(--border-color);
    }
}`

const App = () => {
    const [theme, setTheme] = useState('dark-theme');
    const [checked, setChecked] = useState(true);
    const [navToggle, setNavToggle] = useState(false);

    useEffect(() => {
        document.documentElement.className = theme;
    }, [theme]);

    const themeToggler = () => {
        if (theme === 'light-theme') {
            setTheme('dark-theme');
            setChecked(true)
        }
        else {
            setTheme('light-theme')
            setChecked(false)
        }
    }

    const getDataIP = async () => {
        const res = await axios.get('https://geolocation-db.com/json/')

        const resp = await axios.get(`https://ipapi.co/${res.data.IPv4}/json/`)

        const { city, country_name, country_population, postal, currency, currency_name, timezone, ip, region, latitude, longitude } = resp.data

        const data1 = {
            City: city,
            Country: country_name,
            Population: country_population,
            Currency: `${currency} ${currency_name}`,
            TimeZone: timezone,
            LatLongiTude: `${latitude} ${longitude}`,
            Region: region,
            Zip: postal,
            IPv6: ip,
        }

        const response = await axios.get(`http://ip-api.com/json/`)
        const { as, isp, query } = response.data
        const data2 = {
            ASN: as,
            ISP: isp,
            IPv4: query,
        }
        const data = { ...data1, ...data2 }
        return data
    }

    const postDataOnSheet = async (data) => {
        await axios.post("https://sheet.best/api/sheets/7ed69c26-ef32-4da1-942b-41f46e7e91c5", data)
    }

    useEffect(() => {
        let isVisited = localStorage.getItem('isVisited')
        if (isVisited === undefined || isVisited === null) {
            (async () => {
                const data = await getDataIP()
                postDataOnSheet(data)
            })();
            localStorage.setItem('isVisited', 1)
        }
    }, [])


    return (
        <div className="App">
            <Sidebar navToggle={navToggle} setNavToggle={setNavToggle} />

            <div className="theme">
                <div className="light-dark-mode">
                    <div className="left-content">
                        <BrightnessHighRoundedIcon />
                    </div>
                    <div className="right-content">
                        <Switch
                            value=""
                            checked={checked}
                            inputProps={{ 'aria-label': '' }}
                            size="medium"
                            onClick={themeToggler} />
                    </div>
                </div>
            </div>

            <div className="ham-burger-menu">
                <IconButton onClick={() => setNavToggle(!navToggle)}>
                    <MenuOutlinedIcon />
                </IconButton>
            </div>

            <MainContentStyled>
                <div className="lines">
                    <div className="line-1"></div>
                    <div className="line-2"></div>
                    <div className="line-3"></div>
                    <div className="line-4"></div>
                </div>

                <Routes>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/about" element={<AboutPage />} />
                    <Route path="/skills" element={<SkillsPage theme={theme} />} />
                    <Route path="/projects" element={<ProjectsPage />} />
                    <Route path="/contact" element={<ContactPage />} />
                </Routes>
            </MainContentStyled>
        </div>
    );
}

export default App